import React from "react";
import { Link } from "react-router-dom";
import { TOOLS } from "../tools/registry";
import Nav from "../components/Nav";
import Footer from "../components/Footer";

export default function ToolsIndex() {
  return (
    <div className="min-h-screen bg-[#e8e4df] text-[#171717]">
      <Nav />
      <main className="pt-28 md:pt-36 pb-20">
        <div className="max-w-5xl mx-auto px-5 md:px-8">
          <div className="tick mb-5">Tools</div>
          <h1 className="font-serif-display text-4xl md:text-6xl leading-[1.03] mb-5"
              data-testid="tools-index-heading">
            Eight calculators, and the working shown.
          </h1>
          <p className="font-mono-tech text-[14px] text-[#525252] leading-relaxed max-w-2xl mb-12">
            Free, no sign-up, and nothing is sent anywhere — every calculation runs
            in your browser. Four of them run the same arithmetic as the Margin
            Audit itself, held to it by a test that fails the build if the two ever
            disagree.
          </p>

          <div className="grid sm:grid-cols-2 gap-4" data-testid="tools-index-list">
            {TOOLS.map((t) => (
              <Link
                key={t.slug}
                to={`/tools/${t.slug}`}
                data-testid={`tools-index-${t.slug}`}
                className="card-cream p-6 border border-transparent hover:border-[#171717] transition-colors"
              >
                <div className="font-serif-display text-2xl leading-tight mb-2">{t.title}</div>
                <div className="font-mono-tech text-[12.5px] text-[#525252] leading-relaxed mb-3">
                  {t.tagline}
                </div>
                {t.mirrorsAudit && (
                  <div className="font-mono-tech text-[10.5px] text-[#9a3412]">
                    Same calculation as the Margin Audit
                  </div>
                )}
              </Link>
            ))}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
